<div class="w-full min-h-screen bg-gray-50 flex justify-center py-6 px-4 overflow-x-hidden">
  <div class="w-full max-w-md">

    <!-- OPERADORA MÓVIL DESACTIVADA
    <div class="relative bg-white shadow rounded-xl p-4 mb-6 w-full" (click)="openWhatsapp()">
      <img
        src="https://cdn.zendy.tel/images/WhatsApp.png" class="w-10 h-10 rounded-full cursor-pointer absolute right-4 top-4 z-10"/>
      <div class="flex items-start gap-3 pr-14">
        <img src="https://cdn.zendy.tel/images/SimZendy.svg" class="w-12 h-12" />
        <div>          <p class="text-black font-semibold text-lg leading-tight whitespace-normal">
            {{ 'HOME.NO_LINE_TITLE' | translate }}
          </p>
          <p class="text-gray-600 text-sm leading-tight whitespace-normal mt-1">
            {{ 'HOME.NO_LINE_SUBTITLE' | translate }}
          </p>
        </div>
      </div>
    </div>
    -->

    <!-- GRID OPTIONS -->
    <div class="grid grid-cols-2 gap-4 w-full">

      <!-- OPERADORA MÓVIL DESACTIVADA
      <div class="bg-white border rounded-xl p-4 shadow-sm flex flex-col justify-between items-center w-full h-40">
        <img src="https://cdn.zendy.tel/images/icon-phone-gray-dark-outlined.svg" class="w-8 h-8 mb-2" />
        <p class="font-medium text-gray-800 text-center">{{ 'HOME.MOBILE_LINES' | translate }}</p>
        <button (click)="openCallModal()" class="bg-red-600 text-white text-sm px-4 py-2 rounded-lg w-full">
          {{ 'HOME.GET_PLAN' | translate }}
        </button>
      </div>
      -->

      <!-- Llamadas Internacionales -->
      <div class="bg-white border rounded-xl p-4 shadow-sm flex flex-col justify-between items-center w-full h-40 col-span-2">
        <img src="https://cdn.zendy.tel/images/world.svg" class="w-8 h-8 mb-2" />
        <p class="font-medium text-gray-800 text-center">
          {{ 'HOME.INTERNATIONAL_CALLS' | translate }}
        </p>
        <button [routerLink]="['/calls']" class="bg-red-600 text-white text-sm px-4 py-2 rounded-lg w-full">
          {{ 'HOME.BTN_CALL' | translate }}
        </button>
      </div>

      <!-- Travel SIM -->
      <div class="bg-white border rounded-xl p-4 shadow-sm flex flex-col justify-between items-center w-full h-40">
        <img src="https://cdn.zendy.tel/images/travelsim.svg" class="w-8 h-8 mb-2" />
        <p class="font-medium text-gray-800 text-center">{{ 'HOME.TRAVEL_SIM' | translate }}</p>
        <button [routerLink]="['/esim']" class="bg-red-600 text-white text-sm px-4 py-2 rounded-lg w-full">
          {{ 'HOME.BUY' | translate }}
        </button>
      </div>

      <!-- Préstamos -->
      <div class="bg-white border rounded-xl p-4 shadow-sm flex flex-col justify-between items-center w-full h-40">
        <img src="https://cdn.zendy.tel/images/prestamo.svg" class="w-8 h-8 mb-2" />
        <p class="font-medium text-gray-800 text-center">{{ 'HOME.LOANS' | translate }}</p>
        <button (click)="openLoan()" class="bg-red-600 text-white text-sm px-4 py-2 rounded-lg w-full">
          {{ 'HOME.APPLY' | translate }}
        </button>
      </div>

    </div>

  </div>
</div>



<!-- ================= MODAL CALLME ================= -->
<div
  *ngIf="callModalOpen"
  class="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-end md:items-center justify-center z-50"
  (click)="closeCallModal()"
>

  <div
    class="bg-white w-full md:w-[380px] rounded-t-3xl md:rounded-2xl p-6 shadow-xl relative animate-slideUp"
    (click)="$event.stopPropagation()"
  >
    <!-- Botón cerrar -->
    <button
      class="absolute right-4 top-4 text-gray-600 text-xl"
      (click)="closeCallModal()"
    >✕</button>

    <!-- FEEDBACK -->
    <div *ngIf="callRequested; else callForm">
      <p class="text-lg font-semibold text-center mt-4">Solicitud recibida</p>
      <p class="text-red-600 text-center mb-4">
        En breve un asesor se pondrá en contacto contigo.
      </p>
    </div>

    <!-- FORM -->
    <ng-template #callForm>

      <p class="text-lg font-semibold text-center mt-4">¿Necesitas ayuda?</p>
      <p class="text-red-600 text-center mb-4">Resolvemos todas tus dudas</p>

      <!-- LLÁMANOS GRATIS -->
      <a
        [href]="'tel:' + phoneNumber"
        class="bg-gray-100 rounded-xl p-3 flex items-center mb-4 cursor-pointer"
      >
        <img src="https://cdn.zendy.tel/images/icon-phone-primary-outlined.svg" class="w-6 h-6 mr-3" />
        <div>
          <p class="font-semibold leading-none">Llámanos gratis</p>
          <p class="text-gray-700 leading-none">{{ phoneNumber }}</p>
        </div>
        <img src="https://cdn.zendy.tel/images/arrow-right.svg" class="w-4 h-4 ml-auto" />
      </a>

      <!-- TE LLAMAMOS NOSOTROS -->
      <div class="bg-gray-100 rounded-xl p-3">
        <div class="flex items-center mb-3">
          <img src="https://cdn.zendy.tel/images/icon-we-call-red.svg" class="w-6 h-6 mr-3" />
          <div>
            <p class="font-semibold leading-none">O te llamamos nosotros</p>
            <p class="leading-none text-gray-700 text-sm">Solicita ahora tu llamada</p>
          </div>

        </div>

        <!-- INPUT -->
        <div class="mt-2">
          <input
            type="tel"
            maxlength="9"
            [(ngModel)]="callPhone"
            (input)="onlyNumbers()"
            placeholder="Tu número de teléfono"
            class="w-full border rounded-lg p-3 text-sm outline-red-500"
          />
        </div>
        <p *ngIf="errorPhone" class="text-red-600 text-sm mt-1">Debes introducir un teléfono válido</p>

        <!-- BOTÓN -->
        <button
          class="bg-red-600 text-white w-full py-3 rounded-xl mt-4 font-semibold"
          (click)="sendCallRequest()"
        >
          Llamadme
        </button>

      </div>

    </ng-template>

  </div>
</div>
<!-- =============== END MODAL ================= -->


<style>
  .animate-slideUp {
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(60px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
